var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"controls-wrapper"},[_c('div',{staticClass:"controls"},[_vm._t("symbol",function(){return [_c('img',{staticClass:"more",attrs:{"src":"/images/icons/more-vertical.svg"}})]}),_c('div',{staticClass:"controls-dropdown"},[_vm._t("content")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }